module.exports = __webpack_public_path__ + "static/media/gamesWon_500_1000.1319fa04.png";